import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import ProductImageImageComponent from './ProductImageImageComponent'; // import useSizeTypeFromFragments from './useSizeTypeFromFragments';

function ProductImageVideoComponent(_ref) {
  var active = _ref.active,
      alt = _ref.alt,
      mediaSizeMap = _ref.mediaSizeMap,
      shape = _ref.shape,
      shrink = _ref.shrink,
      size = _ref.size,
      src = _ref.src,
      rest = _objectWithoutProperties(_ref, ["active", "alt", "mediaSizeMap", "shape", "shrink", "size", "src"]);

  // const sizeType = useSizeTypeFromFragments(mediaSizeMap, size, shape, shrink);
  return !active ? /*#__PURE__*/React.createElement(ProductImageImageComponent, _extends({}, rest, {
    alt: alt,
    mediaSizeMap: mediaSizeMap,
    active: active,
    shape: shape,
    shrink: shrink,
    size: size,
    src: src
  })) : 'Video';
}

ProductImageVideoComponent.propTypes = {
  active: PropTypes.bool,
  alt: PropTypes.string,
  mediaSizeMap: PropTypes.shape({}),
  shape: PropTypes.oneOf(['square', 'landscape', 'portrait', 'wide', 'tall']).isRequired,
  shrink: PropTypes.oneOf(['crop', 'fit']).isRequired,
  size: PropTypes.oneOf(['mini', 'small', 'normal', 'big']).isRequired,
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))])
};
ProductImageVideoComponent.defaultProps = {
  active: false,
  alt: undefined,
  mediaSizeMap: undefined,
  src: undefined
};
export default ProductImageVideoComponent;